<template>
  <a-row type="flex" justify="center" align="middle" style="min-height: 48px">
    <a-col :sm="24" :md="24">
      <a-row type="flex" justify="center">
        <a-col :sm="24" :lg="24">
          <div class="global-search-wrapper">
            <a-input-group compact style="display: inline-flex">
              <a-select v-model="queryParam.type">
                <a-select-option value="3">微信昵称</a-select-option>
                <a-select-option value="2">微信ID</a-select-option>
                <a-select-option value="1">机器人编号</a-select-option>
              </a-select>
              <a-auto-complete
                class="global-search"
                @select="onSelect"
                @search="handleSearch"
                :style="{ width: '300px' }"
                v-model="SearchValue"
                :dropdown-menu-style="{ width: '300px' }"
                placeholder="关键字"
                optionLabelProp="value"
              >
                <template slot="dataSource">
                  <a-select-option :key="'loading'" v-if="SearchLoading">
                    <a-spin size="small" />
                  </a-select-option>
                  <a-select-option
                    v-else-if="queryParam.type == 3"
                    v-for="item in dataSource"
                    :key="item.nickname + ' ID：' + item.id"
                  >
                    ID：{{ item.id }}，昵称：{{ item.nickname || '未设置' }}
                  </a-select-option>
                  <a-select-option v-else-if="queryParam.type == 1" v-for="item in dataSource" :key="item.id + ''">
                    ID：{{ item.id }}，昵称：{{ item.nickname || '未设置' }}
                  </a-select-option>
                  <a-select-option
                    v-else-if="queryParam.type == 2"
                    v-for="item in dataSource"
                    :key="item.wx_id + ' ID：' + item.id"
                  >
                    ID：{{ item.id }}，昵称：{{ item.nickname || '未设置' }}
                  </a-select-option>
                </template>
                <a-input>
                  <a-button slot="suffix" @click="handleSearch(SearchValue)" class="search-btn" type="primary">
                    {{ primaryBtnText }}
                  </a-button>
                </a-input>
              </a-auto-complete>
            </a-input-group>
          </div>
        </a-col>
      </a-row>
    </a-col>
  </a-row>
</template>

<script>
import DetailList from '@/components/tools/DetailList'
import DeviceApi from '@/api/device'
const DetailListItem = DetailList.Item
export default {
  components: {
    DetailList,
    DetailListItem
  },
  props: {
    // 是否显示机器人信息
    showInfo: {
      type: Boolean,
      default: true
    },
    // 是否自动选取第一个机器人
    selectFirst: {
      type: Boolean,
      default: true
    },
    // 确认按钮文案
    primaryBtnText: {
      type: String,
      default: '搜索机器人'
    }
  },
  data () {
    return {
      // 查询参数
      queryParam: {
        type: '3'
      },
      main_id:'',
      dataSource: [],
      SearchValue: null,
      SearchLoading: false,
      RobotInfoLoading: false,
      currentRobotId: null,
      currentRobot: null,
      main_id:''
    }
  },
  created () {
    this.getData()
    // this.$success({
    //   title: '已帮您加载系统默认数据',
    //   content: (
    //     <div>
    //       <p>当前显示的系统默认数据，如需加载指定机器人数据请在右上角输入框进行拉取配置操作。</p>
    //     </div>
    //   )
    // })
  },
  watch: {
    currentRobotId (newVal) {
      this.getRobotInfo()
      this.$emit('changeRobotId', newVal)
    }
  },
  methods: {
    onSelect (value) {
      if (this.queryParam.type == 3) {
        const arr = this.dataSource.filter((item) => {
          return value == item.nickname + ' ID：' + item.id
        })
        this.currentRobotId = arr[0].id
      } else if (this.queryParam.type == 2) {
        const arr = this.dataSource.filter((item) => {
          return value == item.wx_id + ' ID：' + item.id
        })
        this.currentRobotId = arr[0].id
      } else {
        this.currentRobotId = value
      }
    },

    handleSearch (value) {
      this.$emit('changeRobotId', this.currentRobotId)
      if (this.queryParam.type != 1) {
        value = value.split(' ID：')[0]
      }
      this.getData(value)
    },
    // 获取机器人列表
    getData (keywords = '') {
      const type = this.queryParam.type
      this.SearchLoading = true
      DeviceApi.getList({ type: type, keywords: keywords })
        .then(res => {
          this.dataSource = res.data
          this.main_id=this.dataSource[0].main_id + ''
          localStorage.setItem('main_id', this.main_id);
          if (!this.currentRobotId && this.dataSource[0] && this.selectFirst) {
            this.currentRobotId = this.dataSource[0].id + ''
          }
        })
        .finally(() => {
          this.SearchLoading = false
        })
    },

    getRobotInfo () {
      const currentRobotId = this.currentRobotId
      this.RobotInfoLoading = true
      DeviceApi.getSettingInfo({ id: currentRobotId })
        .then(res => {
          if (res.code === 1) {
            this.currentRobot = res.data.robot_info
          }
        })
        .finally(() => {
          this.RobotInfoLoading = false
        })
    }
  }
}
</script>

<style lang="less" scoped>
.title {
  font-size: 20px;
  line-height: 28px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
  margin-bottom: 16px;
  -webkit-box-flex: 1;
  flex: auto;
}
.robot-info {
  background: #fff;
  border-radius: 5px;
  .avatar {
    margin-right: 24px;
    margin-bottom: 16px;
    // margin-top: 10px;
  }
}
/deep/ .global-search-wrapper {
  padding-right: 50px;
  margin-top: 8px;
}

/deep/ .global-search {
  width: 100%;
  height: 40px;
}

/deep/ .global-search.ant-select-auto-complete .ant-select-selection--single {
  margin-right: -46px;
}

/deep/ .global-search.ant-select-auto-complete .ant-input-affix-wrapper .ant-input:not(:last-child) {
  padding-right: 112px;
}

/deep/ .global-search.ant-select-auto-complete .ant-input-affix-wrapper .ant-input-suffix {
  right: 0px;
}

/deep/ .global-search.ant-select-auto-complete .ant-input-affix-wrapper .ant-input-suffix button {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

/deep/ .global-search-item-count {
  position: absolute;
  right: 16px;
}
</style>
